import * as React from "react";
import { useEffect, useState } from "react";
import {
  Create,
  Form,
  Toolbar,
  ReferenceInput,
  AutocompleteInput,
  ReferenceArrayInput,
  SelectArrayInput,
  NumberInput,
  useGetList,
  TextInput,
  SaveButton,
} from "react-admin";
import { Card, CardContent, Stack, Container, Box } from "@mui/material";
import { useLocation } from "react-router-dom";

export const ScmAnalysesCreate = () => {
  const { data } = useGetList("producttags", {
    filter: { padrao_compra: true },
  });
  const [selectedIds, setSelectedIds] = useState<any[]>([]);

  useEffect(() => {
    if (data && selectedIds.length === 0) {
      const defaultIds = data.map((item) => item.id); // Define os valores iniciais com base nos dados
      setSelectedIds(defaultIds); // Atualiza o estado com os IDs padrão
    }
  }, [data]);

  const optionSkusRenderer = (choice: any) =>
    `${choice.id}. ${choice.prod_xprod}`;

  const optionFornecedorRenderer = (choice: any) =>
    `${choice?.nome_fornec} ${typeof choice?.quant_skus !== "undefined" ? "(" + choice?.quant_skus + " SKUs)" : ""}`;

  // Para receber o parametro do kanban
  const location = useLocation();
  const initialRecord = location.state?.record || {};

  return (
    <Create
      actions={false}
      redirect="edit"
      transform={(values) => {
        if (values.website && !values.website.startsWith("http")) {
          values.website = `https://${values.website}`;
        }
        return values;
      }}
    >
      {/* <Form defaultValues={{ ids_tags: selectedIds }}> */}
      <Form
        defaultValues={{
          // initialRecord,
          config_analise: { id_oc_escala: initialRecord.id_oc_escala },
          filtros_analise: {
            ids_tags: selectedIds,
            id_fornec: initialRecord?.filtros_analise?.id_fornec,
          },
        }}
      >
        <Container maxWidth="md">
          <Card>
            <CardContent>
              <Stack>
                <TextInput
                  source="desc_analise"
                  label="Descrição"
                  InputLabelProps={{ shrink: true }}
                />
                <ReferenceInput
                  source="filtros_analise.id_fornec"
                  reference="suppliers"
                >
                  <AutocompleteInput
                    label="Fornecedor"
                    // optionText="nome_fornec"
                    optionText={optionFornecedorRenderer}
                    filterToQuery={(pesquisa) => ({ pesquisa })}
                  />
                </ReferenceInput>
                <ReferenceArrayInput
                  source="filtros_analise.ids_tags"
                  reference="producttags"
                  perPage={1000}
                  sort={{ field: "nome_tag", order: "ASC" }}
                  fullWidth
                >
                  <SelectArrayInput optionText="nome_tag" label="Tags" />
                </ReferenceArrayInput>
                <Box display={{ md: "block", lg: "flex" }}>
                  <Box flex={1} mr={{ sm: "0.5em" }}>
                    <NumberInput
                      source="filtros_analise.numero_pedido"
                      label="Pedido"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                  <Box flex={1} mr={{ sm: "0.5em" }}>
                    <NumberInput
                      source="filtros_analise.curva_minima"
                      label="Curva Min"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                  <Box flex={1} mr={{ sm: "0.5em" }}>
                    <NumberInput
                      source="filtros_analise.curva_maxima"
                      label="Curva Max"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                  <Box flex={1}>
                    <NumberInput
                      source="config_analise.id_oc_escala"
                      label="ID Escala"
                      InputLabelProps={{ shrink: true }}
                    />
                  </Box>
                </Box>
                <ReferenceInput
                  // source="filtros_analise.codigo_sku"
                  source="filtros_analise.id"
                  reference="products"
                >
                  <AutocompleteInput
                    label="Produto"
                    // optionText="prod_xprod"
                    optionText={optionSkusRenderer}
                    filterToQuery={(codigo_descricao) => ({ codigo_descricao })}
                  />
                </ReferenceInput>
              </Stack>
              {/* <Toolbar /> */}
              <Toolbar>
                <SaveButton alwaysEnable />
              </Toolbar>
            </CardContent>
          </Card>
        </Container>
      </Form>
    </Create>
  );
};
